// src/pwa/src/services/documentsRepoService.ts
// Issue 74 — store generated PDFs in `documents/{type}/{yyyy-mm}/{filename}.pdf`
// in the Gestalt360 GitHub repo. Hands off the binary to githubTransport.

import { putFile } from './githubTransport';
import { blobToBase64 } from './pdfService';

export type DocumentType = 'quote' | 'invoice' | 'budget' | 'report';

export interface SavePdfArgs {
    type: DocumentType;
    reference: string;
    pdf: Blob;
    clientName?: string;
    issuedAt?: Date;
}

export interface SavePdfResult {
    path: string;
    url: string;
    sha: string;
    queued: boolean;
}

function sanitizeFilename(input: string): string {
    return (input || 'document')
        .replace(/\s+/g, '-')
        .replace(/[^A-Za-z0-9._-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 80) || 'document';
}

function fmt(d: Date): string {
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

export async function savePdfToRepo(args: SavePdfArgs): Promise<SavePdfResult> {
    const issuedAt = args.issuedAt || new Date();
    const monthFolder = fmt(issuedAt);
    const filename = `${sanitizeFilename(args.reference)}.pdf`;
    const path = `documents/${args.type}/${monthFolder}/${filename}`;

    const base64 = await blobToBase64(args.pdf);
    const commit = args.clientName
        ? `upload ${args.type} ${args.reference} for ${args.clientName}`
        : `upload ${args.type} ${args.reference}`;
    const result = await putFile({ path, contentBase64: base64, commitMessage: commit });
    return { path, url: result.url, sha: result.sha, queued: !!result.queued };
}
